import React from "react";
import { CChartLine } from "@coreui/react-chartjs";
import {
  //   CBadge,
  CButton,
  CButtonGroup,
  //   CCard,
  //   CCardBody,
  //   CCardFooter,
  //   CCardHeader,
  CCol,
  //   CProgress,
  CRow,
  //   CCallout,
} from "@coreui/react";
// import CIcon from "@coreui/icons-react";
import { useState, useEffect } from "react";
import { getStyle, hexToRgba } from "@coreui/utils";
import firebase from "firebase";
import { getLogoURL } from "../util.js";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
const brandSuccess = getStyle("success") || "#4dbd74";
const brandInfo = getStyle("info") || "#20a8d8";
const brandDanger = getStyle("danger") || "#f86c6b";

const MyLineChart = (attributes) => {
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  const [dates, setDates] = useState({});
  const [mode, setMode] = useState("Month");
  const [labels, setLabels] = useState([]);
  const [apply, setApply] = useState([]);
  const [first, setFirst] = useState([]);
  const [second, setSecond] = useState([]);
  const [third, setThird] = useState([]);
  const [fourth, setFourth] = useState([]);
  const [offer, setOffer] = useState([]);
  const [reject, setReject] = useState([]);

  const jobCategories = {
    swe: "Software Engineering",
    ds: "Data Science",
    pm: "Product Manager",
    qr: "Quant",
    ml: "Machine Learning",
    ba: "Business Analytics",
    other: "Other",
  };

  const invJobCategories = {
    "Software Engineering": "swe",
    "Data Science": "ds",
    "Product Manager": "pm",
    Quant: "qr",
    "Machine Learning": "ml",
    "Business Analytics": "ba",
    Other: "other",
  };

  function handleLineData(event, flag) {
    console.log("handle", dates);
    var value;
    if (flag) value = flag;
    else {
      console.log(event.target.value);
      console.log("key: ", event.target.value);
      value = event.target.value;
    }

    console.log("this is called");
    var labels = [];
    var apply = [],
      first = [],
      second = [],
      third = [],
      fourth = [],
      offer = [],
      reject = [];
    // var m = moment();
    console.log("now: ", moment());
    if (value == "Week") {
      console.log("week called");
      for (var i = 7; i >= 0; i--) {
        var day = moment().subtract(i, "days");
        console.log(day);
        var val = dates[day.year() + "-" + day.month() + "-" + day.date()];
        if (val != null) {
          apply.push(val.numApplied);
          first.push(val.numFirst);
          second.push(val.numSecond);
          third.push(val.numThird);
          fourth.push(val.numFourth);
          offer.push(val.numOffered);
          reject.push(val.numRejected);
        } else {
          apply.push(0);
          first.push(0);
          second.push(0);
          third.push(0);
          fourth.push(0);
          offer.push(0);
          reject.push(0);
        }
        labels.push(day.format("dddd, Do MMM"));
      }
      console.log(apply);
      console.log(labels);
    } else if (value == "Month") {
      console.log("month called");
      for (var i = 31; i >= 0; i--) {
        var day = moment().subtract(i, "days");
        console.log("x", day.year() + "-" + day.month() + "-" + day.date());
        var val = dates[day.year() + "-" + day.month() + "-" + day.date()];
        console.log("val: ", val);
        if (val) {
          apply.push(val.numApplied);
          first.push(val.numFirst);
          second.push(val.numSecond);
          third.push(val.numThird);
          fourth.push(val.numFourth);
          offer.push(val.numOffered);
          reject.push(val.numRejected);
        } else {
          apply.push(0);
          first.push(0);
          second.push(0);
          third.push(0);
          fourth.push(0);
          offer.push(0);
          reject.push(0);
        }
        labels.push(day.format("MMM Do"));
      }
    } else {
      console.log("year called");
      for (var i = 52; i >= 1; i--) {
        var day = moment().subtract(i, "days");
        var val = dates[day.year() + "-" + day.month() + "-" + day.date()];

        console.log(day.year() + "-" + day.month() + "-" + day.date());
        if (val != null) {
          console.log("insidee ur mom", val);
          apply.push(val.numApplied);
          first.push(val.numFirst);
          second.push(val.numSecond);
          third.push(val.numThird);
          fourth.push(val.numFourth);
          offer.push(val.numOffered);
          reject.push(val.numRejected);
        } else {
          apply.push(0);
          first.push(0);
          second.push(0);
          third.push(0);
          fourth.push(0);
          offer.push(0);
          reject.push(0);
        }
        labels.push(day.format("DD/MM/YY"));
      }
    }

    setMode(value);
    setLabels(labels);
    setFirst(first);
    setSecond(second);

    setThird(third);
    setFourth(fourth);
    setApply(apply);
    setOffer(offer);
    setReject(reject);
  }

  useEffect(async () => {
    const companyId = attributes.companyid;
    console.log("compid", companyId);
    console.log("final", attributes.displaycategory);
    console.log("final2", invJobCategories[attributes.displaycategory]);
    const companyDateCollection = await firebase
      .firestore()
      .collection(invJobCategories[attributes.displaycategory])
      .doc(companyId)
      .collection("dates")
      .get();

    const months = {};
    var idx = 0;
    companyDateCollection.forEach((monthSnap) => {
      months[monthSnap.id] = monthSnap.data();
      console.log(idx);
      idx++;
      if (idx == companyDateCollection.size) {
        const dates = {};
        for (const month of Object.keys(months)) {
          for (const date of Object.keys(months[month])) {
            console.log(typeof (month + "-" + date));
            dates[month + "-" + date] = months[month][date];
          }
        }

        console.log("dates: ", dates);

        setDates(dates);
        // handleLineData(undefined, mode);

        var event = undefined;
        var flag = mode;
        console.log("handle", dates);
        var value;
        if (flag) value = flag;
        else {
          console.log(event.target.value);
          console.log("key: ", event.target.value);
          value = event.target.value;
        }

        console.log("this is called");
        var labels = [];
        var apply = [],
          first = [],
          second = [],
          third = [],
          fourth = [],
          offer = [],
          reject = [];
        // var m = moment();
        console.log("now: ", moment());
        if (value == "Week") {
          console.log("week called");
          for (var i = 7; i >= 0; i--) {
            var day = moment().subtract(i, "days");
            console.log(day);
            var val = dates[day.year() + "-" + day.month() + "-" + day.date()];
            if (val != null) {
              apply.push(val.numApplied);
              first.push(val.numFirst);
              second.push(val.numSecond);
              third.push(val.numThird);
              fourth.push(val.numFourth);
              offer.push(val.numOffered);
              reject.push(val.numRejected);
            } else {
              apply.push(0);
              first.push(0);
              second.push(0);
              third.push(0);
              fourth.push(0);
              offer.push(0);
              reject.push(0);
            }
            labels.push(day.format("dddd, Do MMM"));
          }
          console.log(apply);
          console.log(labels);
        } else if (value == "Month") {
          console.log("month called");
          for (var i = 31; i >= 0; i--) {
            var day = moment().subtract(i, "days");
            var val = dates[day.year() + "-" + day.month() + "-" + day.date()];
            if (val) {
              apply.push(val.numApplied);
              first.push(val.numFirst);
              second.push(val.numSecond);
              third.push(val.numThird);
              fourth.push(val.numFourth);
              offer.push(val.numOffered);
              reject.push(val.numRejected);
            } else {
              apply.push(0);
              first.push(0);
              second.push(0);
              third.push(0);
              fourth.push(0);
              offer.push(0);
              reject.push(0);
            }
            labels.push(day.format("MMM Do"));
          }
        } else {
          console.log("year called");
          for (var i = 52; i >= 1; i--) {
            var day = moment().subtract(i, "days");
            var val = dates[day.year() + "-" + day.month() + "-" + day.date()];

            console.log(day.year() + "-" + day.month() + "-" + day.date());
            if (val != null) {
              console.log("insidee ur mom", val);
              apply.push(val.numApplied);
              first.push(val.numFirst);
              second.push(val.numSecond);
              third.push(val.numThird);
              fourth.push(val.numFourth);
              offer.push(val.numOffered);
              reject.push(val.numRejected);
            } else {
              apply.push(0);
              first.push(0);
              second.push(0);
              third.push(0);
              fourth.push(0);
              offer.push(0);
              reject.push(0);
            }
            labels.push(day.format("DD/MM/YY"));
          }
        }

        setMode(value);
        setLabels(labels);
        setFirst(first);
        setSecond(second);

        setThird(third);
        setFourth(fourth);
        setApply(apply);
        setOffer(offer);
        setReject(reject);
      }
    });
  }, []);

  //   useEffect(() => {}, []);
  //   lineDataWeek: {
  //     labels: labels,
  //     datasets: [
  //       {
  //         label: "Num Applied",
  //         fill: false,
  //         lineTension: 0.2,
  //         backgroundColor: "rgba(75,192,192,1)",
  //         borderColor: "rgba(75,192,192,1)",
  //         borderWidth: 2,
  //         data: totNumApplied,
  //       },
  //       {
  //         label: "Num First Round",
  //         fill: false,
  //         lineTension: 0.2,
  //         backgroundColor: "#57E132",
  //         borderColor: "#57E132",
  //         borderWidth: 2,
  //         data: totNumFirst,
  //       },
  //       {
  //         label: "Num Second Round",
  //         fill: false,
  //         lineTension: 0.2,
  //         backgroundColor: "#3284E1",
  //         borderColor: "#3284E1",
  //         borderWidth: 2,
  //         data: totNumSecond,
  //       },
  //       {
  //         label: "Num Third Round",
  //         fill: false,
  //         lineTension: 0.2,
  //         backgroundColor: "#3254E1",
  //         borderColor: "#3254E1",
  //         borderWidth: 2,
  //         data: totNumThird,
  //       },
  //       {
  //         label: "Num Fourth Round",
  //         fill: false,
  //         lineTension: 0.2,
  //         backgroundColor: "#A132E1",
  //         borderColor: "#A132E1",
  //         borderWidth: 2,
  //         data: totNumFourth,
  //       },
  //       {
  //         label: "Num Offered",
  //         fill: false,
  //         lineTension: 0.2,
  //         backgroundColor: "#E1327A",
  //         borderColor: "#E1327A",
  //         borderWidth: 2,
  //         data: totNumOffered,
  //       },
  //       {
  //         label: "Num Rejected",
  //         fill: false,
  //         lineTension: 0.2,
  //         backgroundColor: "rgba(0,0,0,1)",
  //         borderColor: "rgba(0,0,0,1)",
  //         borderWidth: 2,
  //         data: totNumRejected,
  //       },
  //     ],
  //   },

  const defaultOptions = (() => {
    return {
      maintainAspectRatio: false,
      bezierCurve: true,
      legend: {
        display: true,
        position: "top",
      },
      scales: {
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 50,
            },
            gridLines: {
              drawOnChartArea: false,
            },
            // label: "test",
            scaleLabel: {
              display: true,
              labelString: "Time (date)",
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                if (value % 1 === 0) {
                  return value;
                }
              },
              autoSkip: true,
              //   maxTicksLimit: 12,
              //   maxTicksLimit: 5,
              //   stepSize: 1,
              // max: 100,
            },
            gridLines: {
              display: true,
            },
            scaleLabel: {
              display: true,
              labelString: "Number of people",
            },
          },
        ],
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3,
        },
      },
    };
  })();

  const defaultDatasets = (() => {
    return [
      {
        label: "Num applied",
        backgroundColor: hexToRgba(brandInfo, 10),
        borderColor: brandInfo,
        pointHoverBackgroundColor: brandInfo,
        borderWidth: 2,
        data: apply,
      },
      {
        label: "Num 1st round receivers",
        backgroundColor: "transparent",
        borderColor: brandSuccess,
        pointHoverBackgroundColor: brandSuccess,
        borderWidth: 2,
        data: first,
      },
      {
        label: "Num 2nd round receivers",
        backgroundColor: "transparent",
        borderColor: brandDanger,
        pointHoverBackgroundColor: brandDanger,
        borderWidth: 1,
        borderDash: [8, 5],
        data: second,
        hidden: true,
      },
      {
        label: "Num 3rd round receivers",
        backgroundColor: "transparent",
        borderColor: brandDanger,
        pointHoverBackgroundColor: brandDanger,
        borderWidth: 1,
        borderDash: [8, 5],
        data: third,
        hidden: true,
      },
      {
        label: "Num 4th round receivers",
        backgroundColor: "transparent",
        borderColor: brandDanger,
        pointHoverBackgroundColor: brandDanger,
        borderWidth: 1,
        borderDash: [8, 5],
        data: fourth,
        hidden: true,
      },
      {
        label: "Num offered",
        backgroundColor: "transparent",
        borderColor: brandDanger,
        pointHoverBackgroundColor: brandDanger,
        borderWidth: 1,
        borderDash: [8, 5],
        data: offer,
        hidden: true,
      },
      {
        label: "Num rejected",
        backgroundColor: "transparent",
        borderColor: brandDanger,
        pointHoverBackgroundColor: brandDanger,
        borderWidth: 1,
        borderDash: [8, 5],
        data: reject,
        hidden: true,
      },
    ];
  })();

  // render
  return (
    <div>
      <CRow>
        <CCol sm="5">
          <h4 id="traffic" className="card-title mb-0">
            Status Trends
          </h4>
          <div className="small text-muted">Aug 2021 - Jul 2022</div>
        </CCol>
        <CCol sm="7" className="d-none d-md-block">
          <CButtonGroup
            className="float-right mr-3"
            onClick={(e) => {
              handleLineData(e, undefined);
            }}
          >
            {["Week", "Month", "Year"].map((val) => (
              <CButton
                color="outline-secondary"
                key={val}
                className="mx-0"
                active={val === mode}
                value={val}
              >
                {val}
              </CButton>
            ))}
          </CButtonGroup>
        </CCol>
      </CRow>
      <CChartLine
        {...attributes}
        datasets={defaultDatasets}
        options={defaultOptions}
        labels={labels}
      />
    </div>
  );
};

export default MyLineChart;
